export default __webpack_public_path__ + "static/media/_DSF0110-2.32e26410.JPG";